import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { createCustomer } from "../../services/customerService";
import { getCustomerGroups } from "../../services/customerGroupService"; // Import the service

const CreateCustomer = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    address: "",
    customer_type: "",
    group_id: "",
    delivery_schedule: "",
    security_amount: 0,
    advance_amount: 0,
    opening_due: 0,
    due_amount: 0,
    pet_container_balance: 0,
    cool_container_balance: 0,
    created_by: 1, // Example hardcoded user ID
  });

  const [groups, setGroups] = useState([]); // State to hold group data
  const [showMoreOptions, setShowMoreOptions] = useState(false); // Control visibility of more options

  // Fetch customer groups dynamically
  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const groupData = await getCustomerGroups(); // Use the service function
        setGroups(groupData.data);
      } catch (error) {
        console.error("Error fetching customer groups:", error.message);
        toast.error("Failed to load customer groups");
      }
    };

    fetchGroups();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await createCustomer(formData);
      toast.success("Customer created successfully!");
      console.log("Customer Created:", response);

      // Reset form after successful submission
      setFormData({
        name: "",
        mobile: "",
        address: "",
        customer_type: "",
        group_id: "",
        delivery_schedule: "",
        security_amount: 0,
        advance_amount: 0,
        opening_due: 0,
        due_amount: 0,
        pet_container_balance: 0,
        cool_container_balance: 0,
        created_by: 1,
      });
    } catch (error) {
      console.error("Error creating customer:", error.message);
      toast.error(error.message || "Failed to create customer");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-fit bg-gray-100">
      <div className="bg-white p-8 rounded shadow-md w-full max-w-lg">
        <h2 className="text-2xl font-bold mb-6">Create Customer</h2>
        <form onSubmit={handleSubmit}>
          {/* Name */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:outline-none"
              placeholder="Enter customer name"
              required
            />
          </div>

          {/* Mobile */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Mobile</label>
            <input
              type="tel"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:outline-none"
              placeholder="Enter mobile number"
              required
            />
          </div>

          {/* Address */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Address</label>
            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:outline-none"
              placeholder="Enter address"
              required
            />
          </div>

          {/* Customer Type Dropdown */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">
              Customer Type
            </label>
            <select
              name="customer_type"
              value={formData.customer_type}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:outline-none"
              required
            >
              <option value="">Select Type</option>
              <option value="regular">Regular</option>
              <option value="premium">Premium</option>
              <option value="bulk">Bulk</option>
            </select>
          </div>

          {/* Group ID Dropdown */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Group</label>
            <select
              name="group_id"
              value={formData.group_id}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            >
              <option value="">Select Group</option>
              {groups.map((group) => (
                <option key={group.group_id} value={group.group_id}>
                  {group.group_name}
                </option>
              ))}
            </select>
          </div>

          {/* Delivery Schedule Dropdown */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">
              Delivery Schedule
            </label>
            <select
              name="delivery_schedule"
              value={formData.delivery_schedule}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:outline-none"
              required
            >
              <option value="">Select Schedule</option>
              <option value="daily">Daily</option>
              <option value="weekly">Weekly</option>
              <option value="monthly">Monthly</option>
            </select>
          </div>

          {/* More Options Toggle */}
          <div className="mb-4 flex justify-center">
            <button
              type="button"
              onClick={() => setShowMoreOptions(!showMoreOptions)}
              className="w-full max-w-xs bg-gray-500 text-white font-semibold py-2 px-4 rounded-lg shadow-md transition duration-300 ease-in-out hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
            >
              {showMoreOptions
                ? "⬆️ Hide Additional Options"
                : "⬇️ Show Additional Options"}
            </button>
          </div>

          {/* Additional Options */}
          {showMoreOptions && (
            <>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">
                  Security Amount
                </label>
                <input
                  type="number"
                  name="security_amount"
                  value={formData.security_amount}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  placeholder="Enter security amount"
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">
                  Advance Amount
                </label>
                <input
                  type="number"
                  name="advance_amount"
                  value={formData.advance_amount}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  placeholder="Enter advance amount"
                />
              </div>

              {/* opening_due */}

              

              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">
                  Opening Due
                </label>
                <input
                  type="number"
                  name="opening_due"
                  value={formData.opening_due}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  placeholder="Enter opening due"
                />
              </div>

              {/* <div className="mb-4">
                <label className="block text-sm font-medium mb-1">
                  Due Amount
                </label>
                <input
                  type="number"
                  name="due_amount"
                  value={formData.due_amount}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  placeholder="Enter due amount"
                />
              </div> */}

              {/* Cool & Pet Bottle Balance */}
              <div className="flex space-x-4">
                <div className="mb-4 w-1/2">
                  <label className="block text-sm font-medium mb-1">
                    Cool Balance
                  </label>
                  <input
                    type="number"
                    name="cool_container_balance"
                    value={formData.cool_container_balance}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    placeholder="Cool Balance"
                  />
                </div>
                <div className="mb-4 w-1/2">
                  <label className="block text-sm font-medium mb-1">
                    Pet Balance
                  </label>
                  <input
                    type="number"
                    name="pet_container_balance"
                    value={formData.pet_container_balance}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    placeholder="Pet Balance"
                  />
                </div>
              </div>
            </>
          )}

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-blue-500 text-white font-semibold py-3 rounded-xl shadow-md transition duration-300 ease-in-out hover:bg-blue-600 active:scale-95 focus:outline-none focus:ring-2 focus:ring-blue-400 mb-10"
          >
            ➕ Create Customer
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateCustomer;
